import { TColumnFromLs } from '~/types/table';

export const prepareSelectedColumns = (columns: TColumnFromLs[]) => {
  return columns
    .filter((item) => item.id !== 'actions' && item.id !== 'action')
    .map((item) => item.id)
    .join(',');
};
